import styled from 'styled-components';

export const SearchWrapper = styled.section`
  padding: 20px 16px;
`;

export const UserListWrapper = styled.ul`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  box-sizing: border-box;
`;
